// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3fn4i","headerIcon":"header_headerIcon__2-rY7","adjust":"header_adjust__2q-2V"};